import PaginationModel from "@/models/paginationModel";
import nfetch from "@/utils/events/nfetch";

import EstoqueModel from "../models/estoqueModel";

import { iServiceCached } from "./base/iServiceCached";

function mapCombo(dados: EstoqueModel[]) {
    return dados.map(p => ({
        value: p.id!,
        text: p.descricao,
        franquiaId: p.franquiaId,
    }));
}

class EstoqueService extends iServiceCached<EstoqueModel> {
    private cachedByFranquia: { [franquiaId: number]: EstoqueModel[] } = {};

    constructor() {
        super("Estoque");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return mapCombo(retorno);
    }

    public async comboCachedByFranquiaId(franquiaId: number) {
        if (this.cachedByFranquia[franquiaId]) {
            return mapCombo(this.cachedByFranquia[franquiaId]);
        }

        const response = await nfetch(`/${this.controllerName}/ListByFranquiaId?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<EstoqueModel>>();

        this.cachedByFranquia[franquiaId] = response.list;

        return mapCombo(response.list);
    }

    public async estoquesComboVendaCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return mapCombo(retorno.filter(p => p.permiteVenda));
    }
}

export default new EstoqueService();
